import Service from 'react-reservice';

export interface IExperienceServiceContext {
  loading: boolean;
  accountId?: string;
}

const defaultContext: IExperienceServiceContext = {
  loading: false,
  accountId: undefined
};

class ExperienceService extends Service<IExperienceServiceContext> {
  constructor() {
    super();

    this.context = { ...defaultContext };
  }

  setAccountId = (accountId: string) => {
    this.context.accountId = accountId;
  };

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  reset = () => {
    this.context = {
      ...defaultContext
    };
  };
}

export const experienceService = new ExperienceService();
